import styled from 'styled-components';
import tw from 'twin.macro';

import NeedlLogoIcon from '@/assets/needl-logo.svg?react';
import NeedlFullLogo from '@/assets/needl-logo-full.svg?react';
import { Icon } from '@/atoms/Icon';
import { Link } from '@/atoms/Link';
import { Text } from '@/atoms/Text/Text';
import { IconContainer } from '@/components/Atoms/IconContainer/IconContainer';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';
import HelpOutlineIcon from '@/icons/faq.svg?react';
import { NEEDL_PAGES } from '@/utils/needl-pages';

type NavbarBackgroundType = {
  background?: 'gray' | 'white';
  mobile?: boolean;
};

export type NavbarType = NavbarBackgroundType;

const StyledHelpLink = styled(Link)`
  ${tw`flex items-center justify-center w-8 sm:w-20 gap-2`}
`;

const StyledLogo = styled(NeedlLogoIcon)`
  ${tw`h-9`}
`;
const StyledNeedlFullLogo = styled(NeedlFullLogo)`
  ${tw`h-4`}
`;

const StyledContainer = styled.div<Pick<NavbarType, 'background' | 'mobile'>>`
  ${tw`h-16 w-full flex flex-row justify-between items-center px-4 sm:px-12 lg:px-10 py-4 `}
  ${({ background }) => background === 'white' && tw`sm:bg-white`}
  ${({ mobile }) => (!mobile ? tw`fixed top-0 z-30` : null)}
`;

export const Navbar = ({ background = 'gray' }: NavbarType): JSX.Element => {
  const { mobile } = useResponsiveConstants();
  return (
    <StyledContainer background={background} mobile={mobile}>
      <div className='flex gap-1 items-center h-auto'>
        <StyledNeedlFullLogo />
      </div>

      <div className='flex items-center gap-4'>
        <StyledLogo />
        <StyledHelpLink
          href={NEEDL_PAGES.SUPPORT_URL}
          // @todo: confirm event with product
          // onClick={() => trackEvent('help', { help: true, path: 'auth' })}
        >
          <IconContainer dark color='emerald'>
            <Icon size='small' icon={<HelpOutlineIcon />} />
          </IconContainer>
          <Text bold dark className='hidden sm:block' size='lg' color='emerald'>
            Help
          </Text>
        </StyledHelpLink>
      </div>
    </StyledContainer>
  );
};
